export default __webpack_public_path__ + "static/documentary1-57f4c64c02c9d47379bf8931ca5d08de.jpg";